import React, { useState } from 'react';
import { Grid, Typography, Box, useTheme } from '@mui/material';
import TooltipData from './TooltipData';
import CustomTooltip from '@shared/components/Tooltip';
import { currency } from '@shared/hooks/currencies';

const TableColumn = ({ cell, handleNewSearch, isInUSD }) => {
  const theme = useTheme();

  const [threeDaysTooltip, setThreeDaysTooltip] = useState(null);

  const screenSizeWidth = window.innerWidth;

  const handleMouseEnter = id => setThreeDaysTooltip(id);
  const handleMouseLeave = () => setThreeDaysTooltip(null);

  const handleClick = clickedCell => {
    if (clickedCell?.today) {
      document
        .getElementById('flight-results')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (clickedCell?.TotalAmount && clickedCell?.TotalAmount !== '-') {
      handleNewSearch(clickedCell);
    }
  };

  const setBackgroundColorSx = currentCell => {
    const isCheepest =
      currentCell?.TotalAmount &&
      window.vthws &&
      window.vthws.cheepest === currentCell?.TotalAmount;

    const baseSx = {
      display: 'flex',
      placeItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      fontFamily: 'Open Sans',
      fontSize: 14,
      minHeight: 60,
      borderRadius: 0,
      border: '1px solid #E5E5E5',
      cursor: 'pointer',
    };

    if (currentCell?.today) {
      return {
        ...baseSx,
        bgcolor: '#67666A',
        color: '#fff',
      };
    }

    if (isCheepest) {
      return {
        ...baseSx,
        bgcolor: theme.primary,
        color: theme.text1,
      };
    }

    return {
      ...baseSx,
      bgcolor: '#fff',
      color: '#67666A',
    };
  };

  return (
    <Grid item>
      <Grid
        item
        sx={{
          position: 'relative',
          cursor: 'pointer',
          '&:hover': { boxShadow: '0px 3px 0px #00000033', zIndex: 1 },
        }}
        onMouseEnter={() =>
          handleMouseEnter(
            `${cell?.data?.[0]?.horaSalida}${cell?.data?.[1]?.horaSalida}`
          )
        }
        onMouseLeave={handleMouseLeave}
      >
        {cell?.TotalAmount === 0 ? (
          <Typography
            id="cell-typography"
            component="div"
            sx={{ ...setBackgroundColorSx() }}
          >
            <Box
              sx={{
                width: '100%',
                textAlign: 'center',
                transform: 'rotate(45deg)',
              }}
            >
              <span className="loader"></span>
            </Box>
          </Typography>
        ) : (
          <>
            <Typography
              component="div"
              onClick={() => handleClick(cell)}
              sx={setBackgroundColorSx(cell)}
            >
              {cell?.TotalAmount && cell?.TotalAmount !== '-'
                ? currency(cell?.TotalAmount, isInUSD)
                : '-'}
              {window.vthws &&
                window.vthws.cheepest === cell?.TotalAmount &&
                !cell?.today && (
                  <Box sx={{ ml: 0.5 }}>
                    <IconCheck color={theme.text1} />
                  </Box>
                )}
            </Typography>

            {screenSizeWidth >= 900 && (
              <CustomTooltip
                anchor={threeDaysTooltip}
                elementId={`${cell?.data?.[0]?.horaSalida}${cell?.data?.[1]?.horaSalida}`}
                stylesProp={{
                  top: '100px!important',
                  left: '-50px',
                  width: '300px',
                  padding: '0px',
                  paddingTop: '0.6rem',
                }}
              >
                <span className="hiddeOnMouseOver">
                  <TooltipData cell={cell} />
                </span>
              </CustomTooltip>
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default TableColumn;

const IconCheck = ({ color }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 25 25"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2129 0.142822C5.58549 0.142822 0.212891 5.51542 0.212891 12.1428C0.212891 18.7702 5.58549 24.1428 12.2129 24.1428C18.8403 24.1428 24.2129 18.7702 24.2129 12.1428C24.2129 5.51542 18.8403 0.142822 12.2129 0.142822ZM12.2129 2.75024C17.4003 2.75024 21.604 6.95674 21.604 12.1428C21.604 17.3289 17.4003 21.5339 12.2129 21.5339C7.02549 21.5339 2.82177 17.3289 2.82177 12.1428C2.82179 6.95674 7.02549 2.75024 12.2129 2.75024ZM17.925 7.55859C17.3098 6.94336 16.3123 6.94341 15.6971 7.55871L10.984 12.2728C10.361 12.8959 9.33986 12.885 8.7168 12.262C8.10594 11.6511 7.10483 11.6402 6.49377 12.2509C5.88242 12.8618 5.88225 13.8527 6.4934 14.4639L7.64257 15.613L8.45592 16.4264C9.23714 17.2076 10.5038 17.2074 11.2848 16.4259L12.0825 15.6277L17.9249 9.7865C18.5402 9.17133 18.5403 8.17383 17.925 7.55859Z"
      fill={color}
    />
  </svg>
);
